import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import isotonaut from "../../Assets/Projects/isotonaut.png";

function Projects() {
  return (
    <>
      <Particle />
      <Container fluid className="project-section">
        <Container>
          <h1 className="project-heading">
            Our Recent <strong className="cyan">Work </strong>
          </h1>
          <p style={{ color: "white" }}>
            Here are a few projects we've worked on recently.
          </p>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

            <Col xs={12} md={8} lg={4} className="project-card">
              <ProjectCard
                imgPath={isotonaut}
                title="Isotonaut"
                description="Isotonaut is a science-driven space simulation focused on discovery, systems, and progression. Gather isotopes from stellar winds and frozen ice belts, refine them through interactive separation processes, and synthesize new nuclear configurations aboard an orbital station."
                iosLink="https://apps.apple.com/app/isotonaut/id6759672043"
                googlePlayStoreLink="https://play.google.com/store/apps/details?id=com.chonkbox.isotonaut"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Projects;
